<script>
import {onMount } from 'svelte';
import { fade, fly } from 'svelte/transition';
import {supabase} from "./supabaseClient"
import moment from 'moment';  //Remove?
import MobileSelectAttendee from "./MobileSelectAttendee.svelte"
import MobileSelectMood from "./MobileSelectMood.svelte"
import MobileSelectMood2 from "./MobileSelectMood2.svelte"
import MobileViewBoard from "./MobileViewBoard.svelte"

let thisBoard ={}
let attendees = []
let moods = []
let selectedAttendeId = ''
let attendee;
let boardInstances = []
let selectedInstance;
// let mode = 'SELECT_JOIN_AS'
let mode = 'SELECTED_MOOD'

$: selectedEmoji=[]
// $: currentInstanceSentimentColour = sentimentColourScale.filter(a => a.sentiment == '0.3')[0].colourCode


onMount(async () => {
  const urlParams = new URLSearchParams(window.location.search)

  // Get Board
  let { data, error } = await supabase
    .rpc('get_board', {
      _access_key:urlParams.get('accessKey')
    })
    if (error) console.error(error)
    else console.log(data)
    thisBoard = data

    getBoardData()

})

const getBoardData = async () => {

  // Get attendees
  let attendeesArray;
  let { data:attendeeData, attendeeError } = await supabase
  .rpc('get_board_attendees', {
    boardid:thisBoard.id
  })
  if (attendeeError) {
    console.error(attendeeError)
  }
  else {
    attendeesArray =  attendeeData
  }

  // get moods
  let { data: moodData, moodError } = await supabase
    .rpc('get_board_moods', {
      boardid: thisBoard.id
    })

  if (moodError) console.error(moodError)
  else moods=moodData

  // Get Board currentInstanceSentiment
  let { data:instances, instancesError } = await supabase
  .rpc('get_board_instances', {
    boardid:thisBoard.id
  })
  if (instancesError) console.error(error)
  else {
    boardInstances = instances;
     /* Add a place holder for today's date (client-side) */
      // boardInstances = data;

      const today = moment(new Date()).format('YYYY-MM-DD');
      var placeHolderInstance;

      // Check if todau's date is already there
      if (!boardInstances.find(record => record.date === today)){
        let placeHolderInstance = {
          id:'placeholder-today',
          date: today
        }
        var updatedInstances = [...boardInstances,placeHolderInstance]
        updatedInstances.sort((a, b) => new Date(b.date) - new Date(a.date));
        boardInstances = updatedInstances
        }

  }

  // selectedInstance = instances [0]
  selectedInstance = boardInstances [0]

  // Add a property to each attendee indicating if they have submitted a mood
  attendeesArray = attendeesArray.map(attendee => {
    const hasMood = moods.some(mood => mood.attendee_id === attendee.id && mood.board_instance_id === selectedInstance.id);
    return {...attendee, hasMood};
  });

  // Sort attendees so those without a submitted mood come first
  attendeesArray.sort((a, b) => {
    // Both have moods or both don't have moods, retain original order (you might adjust this based on your needs)
    if (a.hasMood === b.hasMood) {
      return 0;
    }
    // If 'a' does not have a mood but 'b' does, 'a' should come first
    return a.hasMood ? 1 : -1;
  });

  // Assign to attendees variable after sorting
  attendees = attendeesArray;

  
}



   var Events = supabase
  .channel('events')
  .on('postgres_changes', { event: '*', schema: 'public', table: 'events' }, (payload) =>
    {
       // console.log('Change received!', payload)
      getBoardData()
    }
  )
  .subscribe()
  
// const Events = supabase
//     .from('events')
//     .on('*', payload => {
//       console.log('Change received!', payload)
//       getBoardData()
//     })
// .subscribe()
</script>


<!-- Page Header -->
<header>
<!-- <img src="images/smallLogo.png" /> -->
  <img src="images/Logo_webclip_256.png" width="28px" height="28px"/>
  <div id="boardTitle">{thisBoard.title}</div>
</header>
<!-- {#if mode == 'SELECT_JOIN_AS'}
  <MobileSelectAttendee attendees={attendees} bind:attendee={attendee} bind:mode={mode} />
{:else if mode == 'SELECT_MOOD' ||  mode == 'SELECTED_MOOD'}
  <MobileSelectMood2 attendees={attendees} moods={moods} currentAttendee={attendee} board={thisBoard} instance={selectedInstance} bind:mode={mode} bind:selectedEmoji={selectedEmoji}/>
{/if} -->

<MobileSelectMood2 attendees={attendees} moods={moods} currentAttendee={attendee} board={thisBoard} instance={selectedInstance} bind:mode={mode} bind:selectedEmoji={selectedEmoji}/>


<style>
:global(body) {
  width: 100vw;
}
:global (.selectedEmojiBox) { border: #96969680 solid 1px;    width: 86px; height: 86px; text-align: -webkit-center; ;display: flex;
    flex-direction: row;align-items: center}
#boardTitle{margin-left: 18px; margin-right: auto; color: var(--blue); font-weight: bold; font-size: 20px}
header{padding-left:15px; padding-top: 4px; padding-bottom: 4px; background-color: white; position: sticky; top: 0px; display: flex; align-items: center; height: 8%}

</style>
